import { GLOBAL } from './../shared/global';
import {Component, AfterViewChecked, ChangeDetectionStrategy, OnDestroy, ViewContainerRef} from '@angular/core';
import {UserService} from '../api/user.service';
import {User, UserFactory} from '../shared/model/user.entity';
import {ROLE} from '../shared/model/role.enum';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/throw';
import {SpinnerService} from '../spinner/spinner.service';
import {NotificationServiceBus} from '../notification/notification.service';
import {tokenNotExpired} from 'angular2-jwt/angular2-jwt';
import {RolePermission} from '../shared/role-permission/role-permission';
import { SubOrganisationFilterService, SubOrganisation } from '../shared/sub-organisation-filter/sub-organisation-filter.service';
import { switchMap, takeUntil, finalize } from 'rxjs/operators';
import { merge } from 'rxjs/observable/merge';
import { Subject } from 'rxjs/Subject';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { PopupComponent } from '../shared/popup/popup.component';

@Component({
    selector: 'app-admin',
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.css'],
    changeDetection: ChangeDetectionStrategy.Default

})

export class UserManagementComponent implements OnDestroy {
    newUser: User = null;
    roles: any;
    users: Array<User> = [];
    userName = '';
    totalItems = 0;
    page = GLOBAL.uPageNumber;
    private pageEmitSubject = new Subject();
    private destroySubject = new Subject();
    dialogRef: MdDialogRef<any>;

    constructor(public spinnerService: SpinnerService,
                public notificationServiceBus: NotificationServiceBus,
                public userDataService: UserService,
                private rolePermission: RolePermission,
                private subOrganisationFilter: SubOrganisationFilterService,
                public dialog: MdDialog,
                private viewContainerRef: ViewContainerRef) {
        this.roles = ROLE;
        this.userName = '';
    }

    ngOnDestroy() {
      this.destroySubject.next();
    }

    onPageEmit(event$) {
      this.pageEmitSubject.next();
        GLOBAL.uPageNumber = event$.page_number;
        GLOBAL.userPageSize = event$.page_size;
        this.newUser = null;
        this.subOrganisationFilter.selected$.pipe(
          switchMap((subOrganisation: SubOrganisation) => {
            this.spinnerService.requestInProcess(true);
            const search = GLOBAL.getUserSearchParameters();
            if (search.get('filter[type]')) {
              search.set('filter[type]', search.get('filter[type]').replace(/\s/g, ''));
            }
            search.set('sub_org', subOrganisation.name);
            return this.userDataService.fetchPaginatedUsers(GLOBAL.uPageNumber, GLOBAL.userPageSize, search)
              .pipe(finalize(() => this.spinnerService.requestInProcess(false)));
          }),
          takeUntil(merge(this.pageEmitSubject, this.destroySubject))
        )
            .subscribe((res: any) => {
                    if (res.status === 200) {
                        let userList = res.data.users.filter((u) => {
                            let result = Boolean(false === this.rolePermission.isDataRestrictedForCurrentUser('user-management', u.type));
                            return result;
                        }).map(u => UserFactory.createUser(u));
                        this.users = userList;
                        this.totalItems = Boolean(res.data.paginates) ? res.data.paginates.total_records : res.data.users.length;
                        this.page = GLOBAL.uPageNumber;
                    }
                },
                err => {
                    this.notificationServiceBus.launchNotification(true, 'There is an error on the server side.');
                });
    }

    onResetPassword(u: User) {
        this.userName = u.first_name + ' ' + u.last_name;
        this.userDataService.resetUser(u.email)
            .subscribe((res: any) => {
                    if (res.status === 200) {
                        let msg = 'The password has been reset for ' + this.userName;
                        this.notificationServiceBus.launchNotification(false, msg);
                    }
                },
                err => {
                    console.log(err);
                    this.notificationServiceBus.launchNotification(true, 'The email address is not registered with us.');
                },
                () => {
                });
    }

    onDeleteUser(user: User) {
      const config = {
        title: 'Delete User',
        cancelTitle: 'No',
        okTitle: 'Yes',
        popupMessage: 'Are you sure you want to permanently delete this profile?'
      };

      this.createModal(config);
        this.dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.confirmDeleteUser(user.id);
          }
        });
    }

  confirmDeleteUser(userId: number) {
    this.userDataService.deleteUser(userId).subscribe((res: any) => {
      if (res.status === 204) {
        let msg = 'Successfully deleted a user';
        this.onPageEmit({ page_number: GLOBAL.uPageNumber, page_size: GLOBAL.userPageSize });
        this.notificationServiceBus.launchNotification(false, msg);
      }
    }, (err) => {
      const messageObj = err.json();
      const popupMessage = messageObj && messageObj.errors ? messageObj.errors : 'Something went wrong while deleting the user. Please try again later.';
      const config = {
        title: 'Can not delete this user',
        okTitle: 'Ok',
        popupMessage
      };
      this.createModal(config);
    });
  }

    createModal(modalConfig: any) {
      let config: MdDialogConfig = {
        disableClose: true,
      };
      config.viewContainerRef = this.viewContainerRef;
      this.dialogRef = this.dialog.open(PopupComponent);
      Object.keys(modalConfig).forEach((key) => {
        this.dialogRef.componentInstance[key] = modalConfig[key];
      });

    }
}



// WEBPACK FOOTER //
// ./src/app/user-management/user-management.component.ts